import React from 'react';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useNotifications } from '../context/NotificationContext';

const NotificationToast: React.FC = () => {
  const { latestToast, dismissToast } = useNotifications();

  return (
    <Snackbar
      open={Boolean(latestToast)}
      autoHideDuration={6000}
      onClose={dismissToast}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {latestToast ? (
        <Alert
          severity={latestToast.severity}
          onClose={dismissToast}
          variant="filled"
          sx={{ width: '100%', maxWidth: 400 }}
        >
          <AlertTitle>{latestToast.title}</AlertTitle>
          {latestToast.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};

export default NotificationToast;
